// extracted by mini-css-extract-plugin
export default {"card":"card_card__-B4bJ","icon":"card_icon__146gB","heading":"card_heading__XB+oj","sub_heading":"card_sub_heading__yBNP1"};